// export const BASE_URL = `https://x50l7egl10.execute-api.us-east-1.amazonaws.com/devStockViewPoint`;
export const BASE_URL = `https://dci8pvww00.execute-api.ap-south-1.amazonaws.com/devStockViewPoint`;
export const API_ROUTES = {
  POST_CALLS: `/admin/postCall`,
  POST_LOGIN: `/shared/userLogin`,
  POST_FEEDS: `/admin/postFeed`,
  POST_PLANS: `/admin/createPlan`,
  POST_FAQ_EDIT_DEL_ADD_UPDATE: "/admin/postFAQ",

  GET_CALLS: `/shared/getCalls`,
  GET_PLANS: `/shared/getPlans`,
  GET_USERS: "/admin/getDashboardData",
  GET_FEED: `/shared/getFeeds`,
  GET_FAQ: "/shared/getFAQ",
  GET_REQUEST_PLANS: `/admin/waitingForApproval`,
  POST_PLAN_APPROVAL: `/customer/planPurchase`,

  PUT_CALLS: `/admin/updateCall`,
  PATCH_UPDATE_PLANS: `/admin/updatePlan`,
  POST_EXTENT_TRIAL_PLAN: "/admin/extendPlan",
  DELETE_PLAN: `/admin/callModifications/deleteCall`,
  EDIT_CALL: `/admin/callModifications/editCall`,
  UPDATE_PLANS: `/admin/updatePlan`,
  CREATE_COUPON: `/admin/coupon/create`,
  GET_COUPONS: `/shared/coupon/get`,
  USER_REVENUE: `/admin/userAnalytics/userRevenue`,
  USER_ANALYTICS: `/admin/userAnalytics/analytics`,
};
